export default __webpack_public_path__ + "static/men4-131bbec7dc06a768658d471177748ca0.webp";